var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "is-menu-open": _vm.isMenuOpen,
        "show-menu-button": _vm.showMenuButton,
        "can-navigate": _vm.canNavigateOnClick || _vm.canSelectOnClick,
        "show-warning": _vm.showWarning,
      },
      attrs: { "data-component": "base-layout-card" },
      on: { click: _vm.onItemClick },
    },
    [
      _vm.isActive
        ? _c("div", { staticClass: "base-layout-card-active-indicator" }, [
            _vm._v("\n    " + _vm._s(_vm.activeLayoutLabel) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.layout.madeByAgent
        ? _c("div", { staticClass: "base-layout-card-local-indicator" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("HITL.ui-customization.layout-card.local-layout")
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "base-layout-card-preview",
          style: _vm.layoutPreviewGrid,
        },
        _vm._l(_vm.layout.items, function (item) {
          return _c("div", {
            key: item.key,
            staticClass: "base-layout-card-preview-item",
            style: _vm.getPreviewItemStyle(item),
          })
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "base-layout-card-info" }, [
        _c(
          "div",
          { staticClass: "base-layout-card-info-header" },
          [
            _vm.showBookmarkButton
              ? _c(
                  "or-tooltip",
                  {
                    attrs: { text: _vm.bookmarkTooltipText },
                    model: {
                      value: _vm.isBookmarkTooltipVisible,
                      callback: function ($$v) {
                        _vm.isBookmarkTooltipVisible = $$v
                      },
                      expression: "isBookmarkTooltipVisible",
                    },
                  },
                  [
                    _c("or-icon-button", {
                      staticClass: "base-layout-card-info-bookmark",
                      class: { "is-bookmarked": !!_vm.layout.bookmarkedAt },
                      attrs: {
                        "data-button": "base-layout-card-bookmark",
                        icon: _vm.bookmarkIcon,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("bookmark")
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "base-layout-card-info-name",
                attrs: { "data-text": "base-layout-card-info-name" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t(_vm.layout.name)) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.showMenuButton
              ? _c("or-icon-button", {
                  ref: "button",
                  attrs: {
                    "data-button": "base-layout-card-menu",
                    icon: "more_vert",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.isMenuOpen = true
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showMenuButton
              ? _c(
                  "or-menu",
                  {
                    ref: "menu",
                    attrs: {
                      trigger: _vm.buttonRoot,
                      "is-open": _vm.isMenuOpen,
                      "data-menu": "base-layout-card-menu",
                    },
                    on: {
                      open: function ($event) {
                        _vm.isMenuOpen = true
                      },
                      close: function ($event) {
                        _vm.isMenuOpen = false
                      },
                    },
                  },
                  _vm._l(_vm.menuOptions, function (ref) {
                    var value = ref.value
                    var label = ref.label
                    var isDisabled = ref.isDisabled
                    return _c(
                      "or-menu-item",
                      {
                        key: value,
                        attrs: {
                          "data-menu-item": value,
                          disabled: isDisabled,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onMenuItemClick(value, !!isDisabled)
                          },
                        },
                      },
                      [_vm._v("\n          " + _vm._s(label) + "\n        ")]
                    )
                  }),
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.layout.description
          ? _c("div", { staticClass: "base-layout-card-info-description" }, [
              _vm._v("\n      " + _vm._s(_vm.layout.description) + "\n    "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("or-confirm", {
        ref: "confirm",
        attrs: {
          "is-open": _vm.isDeleteConfirmOpen,
          "title-text": _vm.$t(
            "HITL.ui-customization.layout-card.delete-layout-title"
          ),
          "confirm-type": "d",
        },
        on: { confirm: _vm.onDeleteConfirm, close: _vm.onDeleteCancel },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "i18n",
                  {
                    attrs: {
                      slot: "content",
                      path: "HITL.ui-customization.layout-card.delete-layout-description",
                    },
                    slot: "content",
                  },
                  [
                    _c("strong", { attrs: { slot: "text" }, slot: "text" }, [
                      _vm._v(
                        "\n          " + _vm._s(_vm.tLayoutLabel) + "\n        "
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }